import React from "react";

import {flexAbsoluteCenter, mb, position} from "@pg-design/helpers-css";
import {Picture} from "@pg-design/picture-module";
import {appendQueryString} from "@pg-mono/request";
import {rpAppLink} from "@pg-mono/rp-routes";

const finishingDesktop = require("../../assets/article_architect_banner/finishing-desktop.png");
const finishingMobile = require("../../assets/article_architect_banner/finishing-mobile.png");
const renovationDesktop = require("../../assets/article_architect_banner/renovation-desktop.png");
const renovationMobile = require("../../assets/article_architect_banner/renovation-mobile.png");
const styleDesktop = require("../../assets/article_architect_banner/style-desktop.png");
const styleMobile = require("../../assets/article_architect_banner/style-mobile.png");

export enum ArchitectLinkCategories {
    STYLE = "style",
    FINISHING = "wyposazenie-wnetrz",
    RENOVATION = "remont"
}

interface IProps {
    category: ArchitectLinkCategories;
}

export const ArticleArchitectBanner = (props: IProps) => {
    const url = appendQueryString(rpAppLink.architect.list(), {
        utm_campaign: "architekt",
        utm_medium: "baner",
        utm_source: "artykul"
    });

    const getSource = () => {
        switch (props.category) {
            case ArchitectLinkCategories.STYLE:
                return [
                    {minWidthPX: 720, src: styleDesktop, height: 250, width: 720},
                    {minWidthPX: 0, src: styleMobile, height: 250, width: 320}
                ];
            case ArchitectLinkCategories.FINISHING:
                return [
                    {minWidthPX: 720, src: finishingDesktop, height: 250, width: 720},
                    {minWidthPX: 0, src: finishingMobile, height: 250, width: 320}
                ];
            case ArchitectLinkCategories.RENOVATION:
                return [
                    {minWidthPX: 720, src: renovationDesktop, height: 250, width: 720},
                    {minWidthPX: 0, src: renovationMobile, height: 250, width: 320}
                ];
            default:
                return [];
        }
    };

    const getAlt = () => {
        switch (props.category) {
            case ArchitectLinkCategories.STYLE:
                return "aranżacja mieszkania z architektem";
            case ArchitectLinkCategories.FINISHING:
                return "wykończenie mieszkania z architektem";
            case ArchitectLinkCategories.RENOVATION:
                return "remont mieszkania z architektem";
            default:
                return "architekci";
        }
    };

    return (
        <div css={[mb(4), flexAbsoluteCenter, position("relative")]}>
            <a href={url} target="_blank">
                <Picture sources={getSource()} alt={getAlt()} />
            </a>
        </div>
    );
};
